<script setup>
// §8.1 GlobalSearch. Input border is a graphical object — 3:1 min (§7).
import { ref } from 'vue'
import LIcon from '../base/Icon.vue'
defineProps({
  placeholder: { type: String, default: 'Search clients, days, people…' },
})
const model = defineModel({ default: '' })
const focused = ref(false)
</script>

<template>
  <div class="l-search" :class="{ focused }">
    <LIcon name="magnifying-glass" :size="16" />
    <input
      v-model="model"
      type="search"
      :placeholder="placeholder"
      aria-label="Search"
      @focus="focused = true"
      @blur="focused = false"
    />
    <kbd v-if="!model" aria-hidden="true">/</kbd>
  </div>
</template>

<style scoped>
.l-search {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  padding: 8px 12px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r);
  min-height: var(--target-min);
}
.l-search.focused {
  border-color: var(--interactive);
}
.l-search :deep(i) {
  color: var(--icon);
  flex: none;
}
input {
  flex: 1;
  min-width: 0;
  border: 0;
  background: none;
  font-family: var(--font-ui);
  font-size: var(--text-sm);
  color: var(--text);
}
input::placeholder {
  color: var(--text-3);
}
input:focus-visible {
  outline: none;
}
kbd {
  font-family: var(--font-ui);
  font-size: 11px;
  font-weight: 600;
  color: var(--text-3);
  background: var(--surface-sunken);
  border: 1px solid var(--line);
  border-radius: 5px;
  padding: 1px 6px;
}
</style>
